export enum ESelectedButtons {
    first = 0,
    second = 1,
    third = 2,
    fourth = 3
}